/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Email_InvalidInputs */



/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Team_Manager_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_email_invalid = /** @type {((inputs?: Team_Manager_Email_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Email_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez une adresse e-mail valide.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie eine gültige E-Mail-Adresse ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un indirizzo email valido.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите корректный адрес электронной почты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduce una dirección de correo válida.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入有效的电子邮件地址。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("有効なメールアドレスを入力してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक मान्य ईमेल पता दर्ज करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Introduza um endereço de email válido.")
	return /** @type {LocalizedString} */ ("Enter a valid email address.")
});